module.exports = __webpack_public_path__ + "img/eth-blocks-3.0bb9b5c7.jpg";